import { createStyles } from "@material-ui/core";

export default createStyles({

  deliverySelect: { }

});